import App from './MetalStudApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iMetalStud', <App />);
